import { render, staticRenderFns } from "./UnsereFamilie.vue?vue&type=template&id=69f65dc4&scoped=true&"
import script from "./UnsereFamilie.vue?vue&type=script&lang=js&"
export * from "./UnsereFamilie.vue?vue&type=script&lang=js&"
import style0 from "./UnsereFamilie.vue?vue&type=style&index=0&id=69f65dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f65dc4",
  null
  
)

export default component.exports